import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { AppShell } from "@/components/app-shell";
import { NoteCreationProvider } from "@/components/note-creation-provider";
import { useRequiredUser } from "@/src/auth/use-required-user";

/**
 * 로그인 뒤 화면(전체 노트, 노트 업로드, 챗봇) 공통 레이아웃. 사이드바에 보여줄 사용자 이메일만
 * 여기서 읽고, 나머지 데이터는 각 페이지가 알아서 가져온다.
 * 라우트 레이아웃으로 쓰면 <Outlet/>을, 홈("/")처럼 직접 감쌀 땐 children을 그린다.
 */
export default function AppLayout({ children }: { children?: ReactNode }) {
  const user = useRequiredUser();

  return (
    <NoteCreationProvider>
      <AppShell userEmail={user.email ?? "사용자"}>{children ?? <Outlet />}</AppShell>
    </NoteCreationProvider>
  );
}
